import type { IconComponent } from '../types';

/**
 * Renders a share icon.
 */
export const Share: IconComponent = ({
  width,
  height,
  ...restOfProps
}) => <svg width={width} height={height} viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...restOfProps} data-sentry-element="svg" data-sentry-component="Share" data-sentry-source-file="index.tsx">
        <path d='M3.5 8.00023V15C3.5 16.1046 4.39543 17 5.5 17H15.5C16.6046 17 17.5 16.1046 17.5 15V8' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' data-sentry-element="path" data-sentry-source-file="index.tsx" />
        <path d='M7.16675 4.35254L10.1465 1.37276C10.3418 1.1775 10.6584 1.1775 10.8536 1.37276L13.8334 4.35254' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' data-sentry-element="path" data-sentry-source-file="index.tsx" />
        <line x1='10.4604' y1='11.25' x2='10.4604' y2='2.75' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' data-sentry-element="line" data-sentry-source-file="index.tsx" />
    </svg>;